import jQuery from 'jquery';
import {createAction} from 'redux-actions';

import {Airport, Map, Marker} from './actions';

const Animator = jQuery('html, body, .page-wrapper');

const airportsLoaded = createAction(Airport.loaded);
const airportActiveAction = createAction(Airport.active);

export const airportActive = (icao, scroll = false) => (dispatch, getState) => {
    const {active} = getState();

    if (icao === active && scroll) {
        const id = `airport-${icao}`;
        const node = document.getElementById(id);
        const {top} = node.getBoundingClientRect();

        return Animator.animate({scrollTop: top}, 'slow');
    }

    return dispatch(airportActiveAction(icao));
};

export const airportInactive = createAction(Airport.inactive);

const changeMarker = createAction(Marker.change);

export const mapClicked = (x, y, width, height) => (dispatch, getState) => {
    const {start, destination, RegionID, SearchURL} = getState();
    const marker = {x, y, width, height};

    if (start === null || destination) {
        return dispatch(changeMarker({start: marker, destination: null}));
    }

    dispatch(changeMarker({destination: marker}));

    jQuery.ajax(SearchURL, {
        data: {
            region: RegionID,
            start_x: start.x,
            start_y: start.y,
            destination_x: x,
            destination_y: y,
            image_width: width,
            image_height: height,
        },
        success: ({success, airports}) => {
            if (success) dispatch(airportsLoaded(airports));
        },
    });
};

export const closeMap = createAction(Map.close);
export const openMap = createAction(Map.open);
